export default __webpack_public_path__ + "static/media/isa-03.be6d0b2e.jpg";